import { CLASSIC_SITE_BASE } from "./classicSite.constants";

/**
 * Build path under the classic-site silo prefix.
 * @param {string} segment
 */
export function classicSitePath(segment = "") {
  const normalized = segment.startsWith("/") ? segment.slice(1) : segment;
  return normalized ? `${CLASSIC_SITE_BASE}/${normalized}` : CLASSIC_SITE_BASE;
}

/**
 * @param {unknown} err
 */
export function formatClassicSiteError(err) {
  if (!err) return "Unknown error";
  if (typeof err === "string") return err;
  if (err.message) return err.message;
  return String(err);
}

/**
 * Resolve hoodie API base for display (env may be unset in local dev).
 * @param {boolean} configured
 * @param {string} [baseUrl]
 */
export function hoodieConfigMessage(configured, baseUrl) {
  if (configured) {
    return `Hoodie API: ${baseUrl || "(configured)"}`;
  }
  return "REACT_APP_HOODIE_API_BASE_URL is not set — read-only public pages will not load data.";
}
